"use client";

import { useMenuItem } from "../__chunks/UXB73EBH.js";
import { MenuItemCheckedContext, useMenuScopedContext } from "../__chunks/SJPAIJOW.js";
import "../__chunks/QVEJ36PB.js";
import { useRadio } from "../__chunks/NETION43.js";
import "../__chunks/MDCSFLUU.js";
import "../__chunks/L63MOBXC.js";
import "../__chunks/NSB34BGG.js";
import "../__chunks/SZHY72KI.js";
import "../__chunks/ZHUQ44XA.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/DPAO6G5R.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/7FZLUSKW.js";
import "../__chunks/CTKPPFRS.js";
import { useInitialValue, useWrapElement } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-item-radio.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
function getValue(prevValue, value, checked) {
  if (checked === void 0) return prevValue;
  if (checked) return value;
  return prevValue;
}
var useMenuItemRadio = createHook(function useMenuItemRadio2(_a) {
  var _b = _a,
    store = _b.store,
    name = _b.name,
    value = _b.value,
    checked = _b.checked,
    onChangeProp = _b.onChange,
    _b$hideOnClick = _b.hideOnClick,
    hideOnClick = _b$hideOnClick === void 0 ? false : _b$hideOnClick,
    props = __objRest(_b, ["store", "name", "value", "checked", "onChange", "hideOnClick"]);
  var context = useMenuScopedContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "MenuItemRadio must be wrapped in a MenuList or Menu component");
  var defaultChecked = useInitialValue(props.defaultChecked);
  useEffect(function () {
    store == null ? void 0 : store.setValue(name, function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return getValue(prevValue, value, defaultChecked);
    });
  }, [store, name, value, defaultChecked]);
  useEffect(function () {
    if (checked === void 0) return;
    store == null ? void 0 : store.setValue(name, function (prevValue) {
      return getValue(prevValue, value, checked);
    });
  }, [store, name, value, checked]);
  var isChecked = store.useState(function (state) {
    return state.values[name] === value;
  });
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(MenuItemCheckedContext.Provider, {
      value: !!isChecked,
      children: element
    });
  }, [isChecked]);
  props = __spreadValues({
    role: "menuitemradio"
  }, props);
  props = useRadio(__spreadValues({
    name: name,
    value: value,
    checked: isChecked,
    onChange: function onChange(event) {
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented) return;
      var element = event.currentTarget;
      store == null ? void 0 : store.setValue(name, function (prevValue) {
        return getValue(prevValue, value, checked != null ? checked : element.checked);
      });
    }
  }, props));
  props = useMenuItem(__spreadValues({
    store: store,
    hideOnClick: hideOnClick
  }, props));
  return props;
});
var MenuItemRadio = memo(forwardRef(function MenuItemRadio2(props) {
  var htmlProps = useMenuItemRadio(props);
  return createElement(TagName, htmlProps);
}));
export { MenuItemRadio, useMenuItemRadio };